export default "__VITE_ASSET__BUUlEMnJ__"